var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8612 6.62895H14.2975V6.59991H7.99866V9.39937H11.954C11.3769 11.029 9.82636 12.1988 7.99866 12.1988C5.67966 12.1988 3.79947 10.3186 3.79947 7.99964C3.79947 5.68063 5.67966 3.80044 7.99866 3.80044C9.06911 3.80044 10.043 4.20426 10.7845 4.86389L12.7641 2.88432C11.5141 1.71939 9.84211 1.00098 7.99866 1.00098C4.13365 1.00098 1 4.13463 1 7.99964C1 11.8647 4.13365 14.9983 7.99866 14.9983C11.8637 14.9983 14.9973 11.8647 14.9973 7.99964C14.9973 7.53038 14.949 7.07232 14.8612 6.62895Z",
    fill: "#FFC107"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.80859 4.74211L4.108 6.42844C4.73019 4.88803 6.237 3.80044 8.00031 3.80044C9.07076 3.80044 10.0446 4.20426 10.7861 4.86389L12.7657 2.88432C11.5157 1.71939 9.84376 1.00098 8.00031 1.00098C5.31212 1.00098 2.98087 2.51864 1.80859 4.74211Z",
    fill: "#FF3D00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.004 14.999C9.81175 14.999 11.4543 14.3072 12.6963 13.1821L10.5302 11.3492C9.80389 11.9015 8.91643 12.2002 8.004 12.1995C6.18365 12.1995 4.63799 11.0388 4.0557 9.41895L1.77344 11.1774C2.93172 13.4439 5.28397 14.999 8.004 14.999Z",
    fill: "#4CAF50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8625 6.62963H14.2988V6.60059H8V9.40005H11.9553C11.6793 10.1756 11.1821 10.8534 10.5251 11.3495L10.5262 11.3488L12.6923 13.1818C12.539 13.3211 14.9987 11.4997 14.9987 8.00032C14.9987 7.53106 14.9504 7.073 14.8625 6.62963Z",
    fill: "#1976D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/googleIcon.51f9d17550f5014c790b54387f4e4df8.svg";
export { ForwardRef as ReactComponent };